import { Injectable } from '@angular/core';
// import { CachePersistor } from 'apollo-cache-persist';
import {
    InMemoryCache,
    // NormalizedCacheObject
} from 'apollo-cache-inmemory';

@Injectable({
    providedIn: 'root',
})
export class PersistorService {
    cache: InMemoryCache;
    // persistor: CachePersistor<NormalizedCacheObject>;

    constructor() {
        this.cache = new InMemoryCache({
            dataIdFromObject: o => o.id,
        });
        // { dataIdFromObject: o => o.id }

        // this.persistor = new CachePersistor({
        //     cache: this.cache,
        //     storage: window.localStorage,
        // });
    }
}
